/**
 * Derived view state for the Hidden Projects page.
 *
 * Kept out of the component so the rules can be asserted directly — the chip in
 * particular is a claim about what is on screen, and HU-05 was it outliving the
 * projects it referred to.
 */

/** Nothing came back, and we know that for a fact (loaded, not mid-flight, no error). */
export const shouldShowEmptyState = ({ hasLoaded, isLoading, isError, count = 0 } = {}) =>
  !!hasLoaded && !isLoading && !isError && count === 0;

/**
 * HU-05: "Showing hidden projects only" must not survive into an empty result — the
 * empty state explains what happened instead, and the error state has its own message.
 */
export const shouldShowStateChip = (state) => !shouldShowEmptyState(state) && !state?.isError;

/**
 * Distinguish "you have not hidden anything" from "your filters excluded everything",
 * so an empty page never reads as though the feature is broken.
 */
export const emptyStateMessage = ({ search, organisationId } = {}) =>
  search || organisationId
    ? 'No hidden projects match this filter'
    : 'No projects are hidden from the dashboard';
